import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IAddress } from './address'
import { IProviderType } from './providerType'
import { INpiType } from './npiType'
import { IPhoneNumber } from './phoneNumber'
import { IMarket } from './market'
import { ODataService } from 'common-services'

export interface IProvider extends IModelBase {
  Name: string
  Abbreviation: string
  OrganizationNameOverride: string
  MailingAddressId: number
  MailingAddress: IAddress
  PhysicalAddressId: number
  PhysicalAddress: IAddress
  LocationCoverageAddressId: number
  LocationCoverageAddress: IAddress
  EmailAddress: string
  PhoneNumber: string
  PhoneNumber1Id: number
  PhoneNumber1: IPhoneNumber
  Local911PhoneNumber: string
  Local911PhoneNumber1Id: number
  Local911PhoneNumber1: IPhoneNumber
  ModifiedByFullName: string
  ModifiedOn: Date
  OrganizationPhoneNumberOverride: string
  OrganizationPhoneNumberOverride1Id: number
  OrganizationPhoneNumberOverride1: IPhoneNumber
  Npi: string
  NpiType: INpiType
  NpiTypeId: number
  TaxIdNumber: string
  ProviderTypeId: number
  ProviderType: IProviderType
  IsAnchor: boolean
  MarketId: number
  Market: IMarket
  PeopleSoftOperatingUnit: string
  PeopleSoftVendorId: string
  PeopleSoftLocationId: string
  PeopleSoftOrgUnitName: string
  AccountingName: string
  Term: string
  AccountingMarketId: string
  AccountingMarketName: string
  AccountingVendorId: string
  IanaTimeZone: string
  BankingConfiguration: IBankingConfiguration
  InterchangeConfiguration: IInterchangeConfiguration
  PayeeAddressConfiguration: IPayeeAddressConfiguration
  PayerAddressConfiguration: IPayerAddressConfiguration
  PayeeAdditionalInformationConfiguration: IPayeeAdditionalInformationConfiguration
  PayerAdditionalInformationConfiguration: IPayerAdditionalInformationConfiguration
  PayeeIdentificationConfiguration: IPayeeIdentificationConfiguration
  PayerIdentificationConfiguration: IPayerIdentificationConfiguration
  PayerTechnicalContactInformationConfiguration: IPayerTechnicalContactInformationConfiguration
}

export interface IPayeeAddressConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  AddressLine1: string
  AddressLine2: string
  CityName: string
  StateCode: string
  StateId: number
  PostalCode: string
}

export interface IPayerAddressConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  AddressLine1: string
  AddressLine2: string
  CityName: string
  StateCode: string
  StateId: number
  PostalCode: string
}

export interface IPayeeAdditionalInformationConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  ReferenceIdentificationQualifier: string
  ReferenceIdentification: string
}

export interface IPayerAdditionalInformationConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  ReferenceIdentificationQualifier: string
  ReferenceIdentification: string
}

export interface IInterchangeConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  ISA05SenderIdQualifier: string
  ISA06SenderId: string
  ISA07ReceiverIdQualifier: string
  ISA08ReceiverId: string
}

export interface IBankingConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  BPR06PayerRoutingNumberQualifier: string
  BPR07PayerRoutingNumber: string
  BPR08PayerAccountNumberQualifier: string
  BPR09PayerAccountNumber: string
  BPR10PayerIdentifier: string
  BPR12PayeeRoutingNumberQualifier: string
  BPR13PayeeRoutingNumber: string
  BPR14PayeeAccountNumberQualifier: string
  BPR15PayeeAccountNumber: string
}

export interface IPayeeIdentificationConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  Name: string
  IdentificationCode: string
  IdentificationCodeQualifier: string
}

export interface IPayerIdentificationConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  Name: string
  IdentificationCode: string
  IdentificationCodeQualifier: string
}

export interface IPayerTechnicalContactInformationConfiguration {
  CreatedByIdentity: string
  CreatedOnDateTime: Date
  LastModifiedByIdentity: string
  LastModifiedOnDateTime: Date
  Name: string
  CommunicationNumberQualifier: string
  CommunicationNumber: string
  CommunicationNumberExtension: string
}

@Injectable()
export class ProviderODataService extends ODataService<IProvider> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'Providers'
  }
}
